/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Digital_Literacy_Tech_Affinity27Inputs */

const en_job_form_enum_digital_literacy_tech_affinity27 = /** @type {(inputs: Job_Form_Enum_Digital_Literacy_Tech_Affinity27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digital Literacy and Tech Affinity`)
};

const de_job_form_enum_digital_literacy_tech_affinity27 = /** @type {(inputs: Job_Form_Enum_Digital_Literacy_Tech_Affinity27Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digitale Kompetenz und Technikaffinität`)
};

/**
* | output |
* | --- |
* | "Digital Literacy and Tech Affinity" |
*
* @param {Job_Form_Enum_Digital_Literacy_Tech_Affinity27Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_digital_literacy_tech_affinity27 = /** @type {((inputs?: Job_Form_Enum_Digital_Literacy_Tech_Affinity27Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Digital_Literacy_Tech_Affinity27Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_digital_literacy_tech_affinity27(inputs)
	return en_job_form_enum_digital_literacy_tech_affinity27(inputs)
});
export { job_form_enum_digital_literacy_tech_affinity27 as "job_form_enum_DIGITAL_LITERACY_TECH_AFFINITY" }